module.exports = __webpack_public_path__ + "resources/img/img_sectigo_ssl2_m_en.1650a2a13b3623db753eaf61f4d72dab.png";